import React, { useRef } from "react";

const ResizableHandler = ({
  onResize,
  isActive,
  dimensions,
  position,
  rotation,
}) => {
  const resizeStartRef = useRef({});

  const handleResizeMouseDown = (e, corner) => {
    e.stopPropagation();

    resizeStartRef.current = {
      width: dimensions.width,
      height: dimensions.height,
      x: position.x,
      y: position.y,
      mouseX: e.clientX,
      mouseY: e.clientY,
      rotation,
      corner,
    };

    document.addEventListener("mousemove", handleResizeMouseMove);
    document.addEventListener("mouseup", handleResizeMouseUp);
  };

  const handleResizeMouseMove = (e) => {
    e.preventDefault();

    const { width, height, x, y, mouseX, mouseY, rotation, corner } =
      resizeStartRef.current;

    const dx = e.clientX - mouseX;
    const dy = e.clientY - mouseY;
    const angleRad = (rotation * Math.PI) / 180;

    const scaleX = corner.includes("left") ? -1 : 1;
    const scaleY = corner.includes("top") ? -1 : 1;

    const rotatedDx = dx * Math.cos(-angleRad) - dy * Math.sin(-angleRad);
    const rotatedDy = dx * Math.sin(-angleRad) + dy * Math.cos(-angleRad);

    const newWidth = Math.max(width + rotatedDx * scaleX, 50);
    const newHeight = Math.max(height + rotatedDy * scaleY, 50);

    const offsetX = scaleX === -1 ? width - newWidth : 0;
    const offsetY = scaleY === -1 ? height - newHeight : 0;

    const newX =
      x + offsetX * Math.cos(angleRad) - offsetY * Math.sin(angleRad);
    const newY =
      y + offsetX * Math.sin(angleRad) + offsetY * Math.cos(angleRad);

    requestAnimationFrame(() => {
      onResize({ width: newWidth, height: newHeight, x: newX, y: newY });
    });
  };

  const handleResizeMouseUp = () => {
    document.removeEventListener("mousemove", handleResizeMouseMove);
    document.removeEventListener("mouseup", handleResizeMouseUp);
  };

  return (
    isActive && (
      <>
        <div
          style={{
            position: "absolute",
            top: "-5px",
            left: "-5px",
            width: "15px",
            height: "15px",
            backgroundColor: "#21ba45",
            cursor: "nwse-resize",
          }}
          onMouseDown={(e) => handleResizeMouseDown(e, "top-left")}
        />
        <div
          style={{
            position: "absolute",
            top: "-5px",
            right: "-5px",
            width: "15px",
            height: "15px",
            backgroundColor: "#21ba45",
            cursor: "nesw-resize",
          }}
          onMouseDown={(e) => handleResizeMouseDown(e, "top-right")}
        />
        <div
          style={{
            position: "absolute",
            bottom: "-5px",
            left: "-5px",
            width: "15px",
            height: "15px",
            backgroundColor: "#21ba45",
            cursor: "nesw-resize",
          }}
          onMouseDown={(e) => handleResizeMouseDown(e, "bottom-left")}
        />
        <div
          style={{
            position: "absolute",
            bottom: "-5px",
            right: "-5px",
            width: "15px",
            height: "15px",
            backgroundColor: "#21ba45",
            cursor: "nwse-resize",
          }}
          onMouseDown={(e) => handleResizeMouseDown(e, "bottom-right")}
        />
      </>
    )
  );
};

export default ResizableHandler;
